import EmployeesTable from "./EmployeesTable";

export default EmployeesTable;